import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { gql } from '@apollo/client';
import { nullable } from '@infl-ts/util-io-ts';
import { makeDecodedMutation } from '@infl-ts/util-make-apollo-decoded';
import * as t from 'io-ts';
import { EditShippingAddressOutput } from './codecs';
export var useEditShippingAddressMutation = makeDecodedMutation(gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation EditShippingAddress($input: ShippingAddressInput!) {\n      editShippingAddress(input: $input) {\n        ... on EditShippingAddressErrors {\n          errors {\n            ... on Error {\n              message\n            }\n          }\n        }\n        ... on EditShippingAddressResult {\n          address {\n            address\n            address2\n            city\n            country\n            fullName\n            phoneNumber\n            postalCode\n            region\n          }\n        }\n      }\n    }\n  "]))), EditShippingAddressOutput, t.type({
  input: t.intersection([t.type({
    phoneNumber: t.string,
    fullName: t.string,
    address: t.string,
    city: t.string,
    country: t.string,
    postalCode: t.string
  }), t.partial({
    address2: nullable(t.string),
    region: nullable(t.string)
  })])
}));